<button
  type="button"
  class="flow-button"
  [ngClass]="{
    primary: type === 'primary',
    secondary: type === 'secondary',
    tertiary: type === 'tertiary',
    destructive: type === 'destructive',
    tiny: size === 'tiny',
    small: size === 'small',
    medium: size === 'medium',
    large: size === 'large',
    disabled: disabled,
    iconOnly: !label,
    loading: loading,
  }"
  [ngStyle]="{ width: getWidth(), height: getHeight(), 'background-color': backgroundColor }"
  [disabled]="disabled"
  (click)="onClick($event)">
  <ng-container *ngIf="!loading">
    <img *ngIf="icon && iconLeft" [src]="icon" alt="" />
    <p class="p-semibold" *ngIf="label">{{ label }}</p>
    <img *ngIf="icon && (!iconLeft || doubleIcon)" [src]="icon" alt="" />
  </ng-container>
  <div *ngIf="loading" class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</button>
